export default "__VITE_ASSET__f$Pg_TWv__"